import { Modal } from "antd";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import { MeDto } from "../../../core/models/dtos/me.dto";
import FirebaseService from "../../../core/services/firebase.service";
import ContentKeys from "../../../core/utilities/contentKeys";
import { Images } from "../../../core/utilities/images";
import { IStore } from "../../../core/utilities/reducers";
import { UI } from "../../../core/utilities/ui";
import HomeButton from "../../Buttons/HomeButton/HomeButton";
import ContentKey from "../../ContentKey/ContentKey";
import "./FirstComeModal.scss";

interface IProps {
  me?: MeDto;
  callback: () => void;
}

const FirstComeModal = (props: IProps) => {
  const handleModal = () => {
    FirebaseService.logEvent(FirebaseService.user_count_kmb_home_play_click);
    props.callback();
  };

  return (
    <Modal
      className="first-come-modal"
      maskStyle={UI.modalMaskStyle()}
      open
      closable={false}
      footer={false}
      centered
      destroyOnClose
    >
      <div className="body">
        <img className="logo" src={Images.logo_kgb_app} alt="logo" />

        <ContentKey className="text" contentKey={ContentKeys.NEWCOMER_DESC} />

        <HomeButton
          child={<ContentKey contentKey={ContentKeys.NEWCOMER_BUTTON} />}
          callback={() => handleModal()}
        />
      </div>
    </Modal>
  );
};

const mapDispatchToProps = (dispatch: Dispatch) => {
  return bindActionCreators({}, dispatch);
};
const mapStateToProps = (store: IStore) => {
  return {
    me: store.setMe.me,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(FirstComeModal);
